import { AxiosRequestSender } from '@vue-storefront/sdk-axios-request-sender';
import { client } from '../client';

type EpicorInvoiceItem = {
  InvcDtl_Company: string;
  InvcDtl_LineDesc: string;
  InvcDtl_OurOrderQty: string;
  InvcDtl_OrderNum: string;
  InvcDtl_LineType: string;
  InvcDtl_DocUnitPrice: number;
};

type EpicorInvoice = {
  InvcHead_Company: string;
  InvcHead_InvoiceNum: string;
  InvcHead_InvoiceDate: string;
  Calculated_BTAddressList: string;
  InvcHead_DocInvoiceAmt: number;
  Customer_Name: string;
  OrderHed_OrderComment: string;
  InvcHead_TermsCode: string;
  Items: EpicorInvoiceItem[];
};

export async function getInvoiceDetail(id:string): Promise<EpicorInvoice> {
  const { user: userData} = useUserSession();

  const apiInvoiceClient = new AxiosRequestSender(client)
    .setUrl('invoiceDetail')
    .setMethod('GET')
    .setProps([{id:id, customer_id: userData.value?.epicor_id}])
    .send<EpicorInvoice[]>();

  const epicorInvoice = await apiInvoiceClient;
  const invoiceDetail = epicorInvoice[0];

  const apiInvoiceItemClient = new AxiosRequestSender(client)
    .setUrl('invoiceItems')
    .setMethod('GET')
    .setProps([{id:id, customer_id: userData.value?.epicor_id}])
    .send<EpicorInvoiceItem[]>();

  const apiInvoiceItems = await apiInvoiceItemClient;
  invoiceDetail.Items = apiInvoiceItems;

  return invoiceDetail;
}
